import * as React from "react";
import { Dropdown, Input } from "semantic-ui-react";
import PlayerCardField from "./Fields/PlayerCardField";
import { validEmail } from "../../../../../utils";
import { LIQUID_PLACEHOLDER_REGEX } from "../../../../../utils/liquidHelpers";
import CustomTitleField from "./Fields/CustomTitleField";
import DisplayFieldLabel from "./Fields/DisplayFieldLabel";
import { useFormContext, useWatch } from "react-hook-form";
import { PolymorphicPlayerCard } from "../../../../../services/bedrock";
import { useEffect } from "react";

interface EmailWidgetSettingsProps {
  index: number;
}

const EmailWidgetSettings: React.FC<EmailWidgetSettingsProps> = ({ index }) => {
  const [options, setOptions] = React.useState([
    { key: "Home", value: "Home", text: "Home" },
    { key: "Work", value: "Work", text: "Work" },
    { key: "School", value: "School", text: "School" },
  ]);

  const { control } = useFormContext<PolymorphicPlayerCard>();
  const watchedEmailType = useWatch({ control, name: `widgets.${index}.owner.emailType` });

  useEffect(() => {
    if (!watchedEmailType) return;
    setOptions(prev => {
      if (prev.some(o => o.value === watchedEmailType)) {
        return prev;
      } else {
        return [...prev, { key: watchedEmailType, value: watchedEmailType, text: watchedEmailType }];
      }
    });
  }, [watchedEmailType]);

  return (
    <div className="playerCardWidgetOwner playerCardEmail">
      <div className="playerCardInputsRow">
        <PlayerCardField
          index={index}
          fieldName="email"
          rules={{
            required: "This is required.",
            validate: (value: string) => {
              try {
                const liquidRegex = new RegExp(`^(${LIQUID_PLACEHOLDER_REGEX.source})$`);
                if (validEmail(value) || liquidRegex.test(value)) {
                  return true;
                } else {
                  return "Please enter a valid email";
                }
              } catch {
                return "Please enter a valid email";
              }
            },
          }}
          component={Input}
          fieldLabel="Email"
          placeholder="Email"
          autoComplete="email"
        />
        <PlayerCardField
          index={index}
          fieldName="emailType"
          component={Dropdown}
          fieldLabel={<DisplayFieldLabel index={index} label="Type" fieldName="displayEmailType" />}
          placeholder="Type"
          selection
          search
          clearable
          options={options}
          allowAdditions
          autoComplete="off"
        />
      </div>
      <CustomTitleField index={index} />
    </div>
  );
};
export default EmailWidgetSettings;
